/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */
import { AppState } from "Dataflows/Reducers";
import {
  IStateProvinceDataState,
  IStateProvinceData,
  IStateProvinceOptionList,
} from "../../Interfaces/SiteContent";

/**
 * State Provinces data selector.
 */
export const getStateProvinces = (state: IStateProvinceDataState): IStateProvinceData[] =>
  state.stateProvinces;

/**
 * State Provinces shipping data selector.
 */
export const getStateProvinceShipping = (state: IStateProvinceDataState): IStateProvinceData[] =>
  state.stateProvincesShipping;

/**
 * State Provinces school data selector.
 */
export const getStateProvinceSchool = (state: IStateProvinceDataState): IStateProvinceData[] =>
  state.stateProvincesSchool;

/**
 * State Provinces option list data selector.
 */
export const getStateProvincesOptionList = (
  state: IStateProvinceDataState
): IStateProvinceOptionList[] => state.stateProvincesOptionList;

/**
 * State Provinces option list data selector.
 */
export const getAppStateProvincesOptionList = (state: AppState): IStateProvinceOptionList[] =>
  state.stateProvinceDataState.stateProvincesOptionList;

/**
 * State Province Shipping option list data selector.
 */
export const getstateProvinceShippingOptionList = (
  state: IStateProvinceDataState
): IStateProvinceOptionList[] => state.stateProvincesShippingOptionList;

export const getAppStateStateProvinceShippingOptionList = (
  state: AppState
): IStateProvinceOptionList[] => state.stateProvinceDataState.stateProvincesShippingOptionList;

/**
 * State Province School option list data selector.
 */
export const getStateProvinceSchoolOptionList = (
  state: IStateProvinceDataState
): IStateProvinceOptionList[] => state.stateProvincesSchoolOptionList;

export const getAppStateStateProvinceSchoolOptionList = (
  state: AppState
): IStateProvinceOptionList[] => state.stateProvinceDataState.stateProvincesSchoolOptionList;

/**
 * State Provinces loadError selector.
 */
export const getStateProvinceLoadError = (state: IStateProvinceDataState): string =>
  state.stateProvincesLoadError;

export const getAppStateStateProvinceLoadError = (state: AppState): string =>
  state.stateProvinceDataState.stateProvincesLoadError;

/**
 * State Provinces shipping loadError selector.
 */
export const getStateProvinceShippingLoadError = (state: IStateProvinceDataState): string =>
  state.stateProvincesShippingLoadError;

export const getAppStateStateProvinceShippingLoadError = (state: AppState): string =>
  state.stateProvinceDataState.stateProvincesShippingLoadError;

/**
 * State Provinces school loadError selector.
 */
export const getStateProvinceSchoolLoadError = (state: IStateProvinceDataState): string =>
  state.stateProvincesSchoolLoadError;

export const getAppStateStateProvinceSchoolLoadError = (state: AppState): string =>
  state.stateProvinceDataState.stateProvincesSchoolLoadError;
